import { render, staticRenderFns } from "./DIASOrganizationAttachment.vue?vue&type=template&id=2b1505f4&"
import script from "./DIASOrganizationAttachment.vue?vue&type=script&lang=js&"
export * from "./DIASOrganizationAttachment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports